<div class="custom-input-container" [ngClass]="[size, error ? 'error' : '']">
	@if (label) {
		<label [for]="inputId" class="input-label">{{ label }}@if (required) {<span class="required-mark" aria-hidden="true">*</span>}</label>
	}

	<div class="input-wrapper" [ngClass]="{ 'has-icon-left': icon && iconPosition === 'left', 'has-icon-right': icon && iconPosition === 'right', 'has-toggle': showToggleButton }">
		<!-- Left Icon -->
		@if (icon && iconPosition === 'left') {
			<lucide-icon [name]="icon" class="input-icon icon-left"></lucide-icon>
		}

		<!-- Input Field -->
		<input
			#inputRef
			[type]="currentInputType"
			[placeholder]="placeholder"
			[value]="value || ''"
			[disabled]="disabled"
			[id]="inputId"
			[attr.aria-required]="required || null"
			[attr.aria-invalid]="error || null"
			class="custom-input"
			(input)="onInput($event)"
			(blur)="markAsTouched()" />

		<!-- Password Toggle Button -->
		@if (showToggleButton) {
			<button
				type="button"
				class="password-toggle"
				[disabled]="disabled"
				(click)="togglePasswordVisibility()"
				[attr.aria-label]="(showPassword ? 'common.a11y.hidePassword' : 'common.a11y.showPassword') | transloco"
				[attr.aria-pressed]="showPassword"
				tabindex="-1">
				<lucide-icon [name]="showPassword ? 'EyeOff' : 'Eye'" aria-hidden="true"></lucide-icon>
			</button>
		}

		<!-- Loading Spinner -->
		@if (loading) {
			<span class="input-spinner"></span>
		}

		<!-- Right Icon -->
		@if (icon && iconPosition === 'right' && !loading) {
			<lucide-icon [name]="icon" class="input-icon icon-right"></lucide-icon>
		}

		<!-- Suffix Template (for custom content like card icons) -->
		@if (!icon && suffix) {
			<ng-container *ngTemplateOutlet="suffix"></ng-container>
		}
	</div>

	<!-- Error Message -->
	@if (error && errorMessage) {
		<div class="error-message">{{ errorMessage }}</div>
	}

	<!-- Helper Text -->
	@if (helperText && !error) {
		<div class="helper-text">{{ helperText }}</div>
	}
</div>